export default "__VITE_ASSET__6db9eb4f__"